<div class="mb-1 border-solid border-b border-gray-300 bg-gray-100">
  <span class="text-gray-900 p-3 block text-md font-normal">{{field.name}}</span>
</div>

<div class="p-3">
  <div class="details-list t-60">
    <div title="Nom" class="head">Nom</div>
    <div>{{field.name}}</div>
    <div title="Culture" class="head">Culture</div>
    <div>
      <span [title]="field.crop?.path_str || 'Non Disponible'"
         class="border-b border-dotted border-gray-700">{{field.crop?.name || 'NA'}}</span>
    </div>
    <div title="Superficie Cultivée" class="head">Superficie Cultivée</div>
    <div>{{field.field_crop_cadastral_area}} Ha ({{((field.field_crop_percent || 0) * 100).toFixed(1)}}%)</div>
    <div title="Superficie Totale" class="head">Superficie Totale</div>
    <div>{{field.cadastral_area}} Ha</div>
    <div title="Domaine" class="head">Domaine</div>
    <div>{{field.domain_name}}</div>
    <div title="BU" class="head">BU</div>
    <div>{{field.business_unit_name}}</div>
  </div>
</div>
